<template>
  <section class="mh-skills" id="my-skills">
    <div class="home-v-img">
      <div class="container">
        <div class="row section-separator">
          <div class="section-title text-center col-sm-12">
            <h2>Skills</h2>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="mh-skills-inner">
              <div
                class="mh-professional-skill wow fadeInUp"
                data-wow-duration="0.8s"
                data-wow-delay="0.3s"
              >
                <h3>Technical Skills</h3>
                <div class="each-skills">
                  <div class="each-skills">
                    <div
                      class="candidatos"
                      v-for="(skill, index) in featuredSkills"
                      :key="index"
                    >
                      <div class="parcial">
                        <div class="info">
                          <div class="nome" v-html="skill.name"></div>
                          <div
                            class="percentagem-num"
                            v-html="skill.data"
                          ></div>
                        </div>
                        <div class="progressBar">
                          <div
                            class="percentagem"
                            :style="`width: ${skill.data}`"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div
              class="mh-professional-skills wow fadeInUp"
              data-wow-duration="0.8s"
              data-wow-delay="0.5s"
            >
              <h3>Professional Skills</h3>
              <ul class="mh-professional-progress">
                <li>
                  <div
                    class="mh-progress mh-progress-circle"
                    data-progress="90"
                  ></div>
                  <div class="pr-skill-name">Communication</div>
                </li>
                <li>
                  <div
                    class="mh-progress mh-progress-circle"
                    data-progress="78"
                  ></div>
                  <div class="pr-skill-name">Team Work</div>
                </li>
                <li>
                  <div
                    class="mh-progress mh-progress-circle"
                    data-progress="66"
                  ></div>
                  <div class="pr-skill-name">Project Management</div>
                </li>
                <li>
                  <div
                    class="mh-progress mh-progress-circle"
                    data-progress="88"
                  ></div>
                  <div class="pr-skill-name">Creativity</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    technicalSkills() {
      // I disabled this because it doesn't allow the in-built js events to be triggered
      // in-built js called by "data-progress"
      return this.$store.getters.getTechnicalSkills;
    },
    featuredSkills() {
      // Filter the Object and get only the "featured" ones
      return Object.filter(this.skills, (skill) => skill.featured == true);
    },
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setSkills") {
        if (state.skills != null) {
          this.skills = state.skills;
        }
      }
    });
  },
};
</script>
